import { reduce } from 'ramda'

import { Params, RecipientsInfo } from 'app/dataTypes/transfer/recipients'
import { getIdFromUID, getUserTypeFromUID, createUID } from 'app/dataTypes/transfer/uid'

import type { Request } from '../../../../../index'


type ParamsApi = {
  sender_type: 'Student' | 'Parent'
  sender_id: number
}

export const convertParams = ({ senderUID }: Params): [ParamsApi, null] => {
  return [{
    sender_type: getUserTypeFromUID(senderUID),
    sender_id: getIdFromUID(senderUID),
  }, null]
}

type SendersApi = Array<{
  id: number
  type: 'Student' | 'Parent'
  enabled: boolean
  name: string
  balance: string
  min_amount: string
  max_amount: string
  gender: 'male' | 'female'
  photo: string | null | ''
}>

export const convertResult = (data: SendersApi, params: Params): RecipientsInfo => {
  const { senderUID } = params
  return reduce((acc, val) => {
    const {
      id,
      enabled,
      type,
      name,
      balance: blnc,
      min_amount: min,
      max_amount: max,
      gender,
      photo,
    } = val
    const balance = parseFloat(blnc)
    const minAmount = parseFloat(min)
    const maxAmount = parseFloat(max)

    if (Number.isNaN(balance)) {
      console.warn(`Получен неверный баланс для ${name} (${id}), поэтому не будет участвовать в переводе`)
      return acc
    }

    const recipient = {
      UID: createUID(String(id), type),
      enabled,
      type,
      name,
      balance,
      minAmount: Number.isNaN(minAmount) ? 0 : minAmount,
      maxAmount: Number.isNaN(maxAmount) ? Infinity : maxAmount,
      gender: gender === 'male' || gender === 'female' ? gender : 'androgynous' as const,
      photo: photo || null,
    }

    acc.recipientsBySenderUID[senderUID].push(recipient)
    if (recipient.enabled) {
      acc.activeRecipientsBySenderUID[senderUID].push(recipient)
      acc.hasActiveRecipients = true
    }

    return acc
  }, {
    recipientsBySenderUID: { [senderUID]: [] },
    activeRecipientsBySenderUID: { [senderUID]: [] },
    hasActiveRecipients: false,
  } as RecipientsInfo, data)
}

export const GET_TRANSFER_RECIPIENTS: Request<void, RecipientsInfo, void> = [
  'cabinet/cafeteria/payments/transfer/recipients',
  'get',
  ['data', 'recipients'],
]
